import CASL from '@/utils/constants/casl'

export default {
  path: 'pln-mobile',
  children: [
    {
      path: '',
      name: 'pln-mobile.list',
      meta: {
        action: 'read',
        subject: CASL.ACCESS.PLN_MOBILE
      },
      component: () => import('./list/PLNMobileListPage.vue')
    }
  ]
}
